import { z } from 'zod'

// Reusable Zod schemas. Keep field-level rules here (not inline in pages) so
// the same constraints apply whether the data path is a form, a service call,
// or a test fixture.

export const profileFieldsSchema = z.object({
  first_name: z.string().min(1, 'First name is required').max(60),
  last_name: z.string().min(1, 'Last name is required').max(60),
  city: z.string().min(1, 'City is required').max(80),
  state_code: z.string().min(2, 'State is required').max(3),
  country: z.string().min(2, 'Country is required').max(3),
})

// Accepts E.164-ish numbers with an optional leading + and common punctuation.
// Deliberately lax: the field is optional and we trust users to self-correct.
export const phoneSchema = z
  .string()
  .trim()
  .regex(/^\+?[\d\s().-]{7,20}$/, 'Enter a valid phone number')
  .optional()
  .or(z.literal(''))

export const loginSchema = z.object({
  email: z.string().email('Enter a valid email'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
})

export const registerSchema = loginSchema
  .extend({
    confirmPassword: z.string(),
  })
  .refine((v) => v.password === v.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords must match',
  })

export const tournamentSchema = z.object({
  name: z.string().min(1, 'Name is required').max(120),
  sportId: z.string().uuid('Pick a sport'),
  startDate: z.string().min(1, 'Start date is required'),
  endDate: z.string().min(1, 'End date is required'),
  submissionDeadline: z.string().min(1, 'Submission deadline is required'),
})
